const toStringSafe = (value: any): string => {
    if (value === null || value === undefined) { return ''; }

    return String(value);
};

const trimToString = (value: any): string => {
    return toStringSafe(value).trim();
};

const getPathValue = (obj: any, path: string, fallback: any = '') => {
    if (obj === null || obj === undefined) { return fallback; }
    if (!path) { return fallback; }

    const parts = path.split('.');
    let current = obj;

    for (const part of parts) {
        if (current === null || current === undefined) { return fallback; }

        current = current[part];
    }

    return (current === undefined) ? fallback : current;
};

const toIntOr = (value: any, fallback: number = 0) => {
    const parsed = parseInt(toStringSafe(value), 10);

    return Number.isFinite(parsed) ? parsed : fallback;
};

const isNumericToken = (value: string) => {
    if (value === '') { return false; }

    return !Number.isNaN(Number(value));
};

export const getComponentIdParts = (dataItem: any) => {
    const componentIdToken = trimToString(getPathValue(dataItem, 'componentId', ''));
    const explicitDecimalToken = trimToString(getPathValue(dataItem, 'componentDecimal', ''));

    if (isNumericToken(explicitDecimalToken)) {
        return {
            baseComponentId: toIntOr(getPathValue(dataItem, 'componentId', 0)),
            decimalComponentId: toIntOr(explicitDecimalToken),
            hasDecimalComponentId: true,
            decimalToken: explicitDecimalToken,
        };
    }

    if (componentIdToken.indexOf('.') >= 0) {
        const split = componentIdToken.split('.');
        const baseToken = trimToString(split[0] || '0');
        const decimalToken = trimToString(split[1] || '');
        const hasDecimal = isNumericToken(decimalToken);

        return {
            baseComponentId: toIntOr(baseToken),
            decimalComponentId: hasDecimal ? toIntOr(decimalToken) : 0,
            hasDecimalComponentId: hasDecimal,
            decimalToken: decimalToken,
        };
    }

    return {
        baseComponentId: toIntOr(componentIdToken),
        decimalComponentId: 0,
        hasDecimalComponentId: false,
        decimalToken: '',
    };
};

export const getComponentDisplayId = (dataItem: any) => {
    const componentIdToken = trimToString(getPathValue(dataItem, 'componentId', ''));
    const parts = getComponentIdParts(dataItem);

    if (parts.hasDecimalComponentId) {
        return `${parts.baseComponentId}.${parts.decimalToken}`;
    }

    if (componentIdToken !== '' && Number.isNaN(Number(componentIdToken))) {
        return componentIdToken;
    }

    return toStringSafe(parts.baseComponentId);
};

export const getComponentNameSortKey = (dataItem: any) => {
    const rootName = trimToString(getPathValue(dataItem, 'componentName', ''));
    const nestedName = trimToString(getPathValue(dataItem, 'component.name', ''));
    const name = (rootName !== '') ? rootName : nestedName;

    return name.toLowerCase();
};

export const getComponentStableSortKey = (dataItem: any, fallbackIndex: number = 0) => {
    const objectId = trimToString(getPathValue(dataItem, '_id', ''));
    const inventoryId = trimToString(getPathValue(dataItem, 'inventoryId', ''));
    const componentName = getComponentNameSortKey(dataItem);

    return `${objectId}|${inventoryId}|${componentName}|${fallbackIndex}`;
};

export const getComponentSortFields = (dataItem: any, fallbackIndex: number = 0) => {
    const parts = getComponentIdParts(dataItem);

    return {
        __componentDisplayId: getComponentDisplayId(dataItem),
        __componentSortBase: parts.baseComponentId,
        __componentSortDecimal: parts.hasDecimalComponentId ? parts.decimalComponentId : -1,
        __componentSortName: getComponentNameSortKey(dataItem),
        __componentSortStable: getComponentStableSortKey(dataItem, fallbackIndex),
    };
};



// WEBPACK FOOTER //
// ./src/report/component-sorting.tsx